import * as React from 'react';

import {ButtonCard} from 'shells/card/button-card';
// @ts-expect-error - imported from .js/.jsx file
import {StepIcon} from 'shells/icon/svg/step-icon';
import {ListView} from 'shells/list-view/list-view';
import {StatusBadge} from 'shells/status-badge/status-badge';
import {Body} from 'shells/typography/body';

import type {GetStagesetsUnarchived_stagesets as StagesetUnarchived} from 'nutshell-graphql-types';

import {useGetStagesetsUnarchived} from '../graphql/hooks/use-get-stagesets-unarchived';

import styles from './pipeline-select-existing.module.css';

type Props = {
    selectedStageset: StagesetUnarchived | null | undefined;
    onSelect: (stageset: StagesetUnarchived) => void;
};

export function PipelineSelectExisting(props: Props) {
    const {stagesetsUnarchived, isLoading, error} = useGetStagesetsUnarchived();

    return (
        <div className={styles['list-container']}>
            <ListView
                isLoading={isLoading}
                isError={Boolean(error)}
                isFullWidth={true}
                isFullHeight={true}
                collection={stagesetsUnarchived}
                isOverflowAuto={true}
                itemSpacing={8}
                listPadding={16}
                renderRow={(item) => (
                    <ButtonCard
                        isFullWidth={true}
                        isSelected={Boolean(
                            props.selectedStageset && props.selectedStageset.id === item.id
                        )}
                        onClick={() => props.onSelect(item)}
                    >
                        <div className='pad-16 flex justify-sb full-width border-box'>
                            <Body color='dark' isBold={true} size='small'>
                                {item.name}
                            </Body>
                            <StatusBadge
                                size='mini'
                                level='info'
                                text={getStatusBadgeText(item)}
                                includeIcon={true}
                                customIcon={StepIcon}
                            />
                        </div>
                    </ButtonCard>
                )}
            />
        </div>
    );
}

function getStatusBadgeText(stageset: StagesetUnarchived) {
    const numStages = stageset.stages.length;
    if (numStages === 1) {
        return '1 stage';
    }

    return `${numStages} stages`;
}
